export default __webpack_public_path__ + "static/media/4.278109f8.webp";